import React, {useState} from 'react';
import { useSelector } from 'react-redux';
import { IconSchedule, IconSettings, TextButton } from 'cdk-radial';
import '../styles/completeConfiguration.scss';
import ConfigurationDialog from './ConfigurationDialog';

const AUTO = 'but is not yet active.';
const MANUAL = ' but is waiting to be manually approved. Please check back later.';

const ConfigurationToast = (props) => {

    const {urlParam, redirectURL, entityID} = props;

    const[openDialog, setOpenDialog] = useState(false);


    const state = useSelector(state => state);

    const constants = 
    state &&
    state.solutionInfoSlice &&
    state.solutionInfoSlice.constants;

    const appSubscriptionType = 
    state && 
    state.solutionInfoSlice && 
    state.solutionInfoSlice.solutionInfo &&
    state.solutionInfoSlice.solutionInfo.app_subscriptions &&
    state.solutionInfoSlice.solutionInfo.app_subscriptions.appSubscriptionsType;

    return (
        <div>
        {appSubscriptionType === 'Manual'
            ?  <div className='configure-toast-container configure-manual-app'>
                    <div className='configure-toast-icon configure-manual-icon'>
                        <IconSchedule fill='#ffffff'/>
                    </div>
                    <div className='configure-toast'>
                        <div className='configure-toast-text'>
                            {`${constants.CONFIGURE_SUBSCRIPTION} ${MANUAL}`}
                        </div>
                    </div>
                </div>
            : <div className='configure-toast-container configure-auto-app'>
                <div className='configure-toast-icon configure-auto-icon'>
                <IconSettings fill='#ffffff'/>
                </div>
                <div className='configure-toast'>
                <div className='configure-toast-text'>
                    {`${constants.CONFIGURE_SUBSCRIPTION} ${AUTO}`}
                </div>
                <TextButton 
                dataTestId="text-button-finish-configuration"
                iconColor="primary"
                onClick={()=>{
                    setOpenDialog(true)
                }}
                text='Finish Configuration'
                className='configure-button'
                />
                </div>
            </div>
        }
        <ConfigurationDialog
            urlParam={urlParam} 
            redirectURL={redirectURL} 
            entityID={entityID}
            openDialog={openDialog}
            setOpenDialog={setOpenDialog}
        />
      </div>
    );
}

export default ConfigurationToast;